import { chroniclePureOfflineSessionsAtom } from '@/atoms/chronicle';
import { useAtomValue } from 'jotai';

/**
 * flow 2: true when `sessionId` was recovered from a PURE-OFFLINE
 * Remote recording — the session was created at recovery-bind time
 * (`recoveredMatchVia === 'created_offline'`), so no online live segment ever
 * existed and the session was never interrupted. The "Session Interrupted"
 * surfaces (header pill, session-list ⚠ cell, side-nav icon) suppress while
 * this is true, because the flow-2 recovery-bind row lands in the same
 * `sync_tracking` interrupted set (`live_recording`/`session_created`) that
 * drives them for genuine interruptions.
 *
 * Gated purely by the atom lifecycle: the set is only written by the
 * recovered-event listener on a `created_offline` bind, which requires
 * `release-apps-remote-sync-async-web` on (Rust gates `recording_recovered`
 * behind the pushed flag). Flag OFF ⇒ empty set ⇒ always false. Genuinely
 * interrupted (flow 1) sessions never enter the set, so their badge is
 * untouched.
 */
export function useIsPureOfflineRemoteSession(
  sessionId: string | null | undefined
): boolean {
  const pureOfflineSessions = useAtomValue(chroniclePureOfflineSessionsAtom);
  if (!sessionId) return false;
  return pureOfflineSessions.has(sessionId);
}
